<style lang="css">
    body.welcome {
        background: #000 url("/static/img/stars_small.png") center center fixed no-repeat;
        width: 100%;
        height: 100%;
        background-size: cover;
        color: #000;
    }
</style>
<style lang="css" scoped>
    div.jumbotron.marquee {
        background-color: #fff !important;
    }
    .meta {
        color: #777;
        font-size: .98em;

    }

    .meta-bit {
        color: #333;
        font-weight: bold;
    }

    .tech-label + .tech-label {
        margin-left: 10px;
    }
    a#txt:hover {
        color: #0056b3 !important;
        text-decoration: none;
    }
    .page-header {
        border-bottom: 1px solid #EEE;
        margin: 10px 0;
        padding-bottom: 0;
    }  
    a:hover {
    color: #0056b3 !important;
    text-decoration: none;
  }
</style>

<template>
    <b-container class="bv-example-row">
        <b-jumbotron style="max-width: 70rem;min-width: 70rem;" class="marquee">
            <template slot="header">
                <div style="font-size: 45px;"><b>Welcome <img src="/static/img/welcome2.png" alt="welcome" class="d-inline-block align-top" width="50" height="50" ></b></div>
                <!-- <b>Welcome <img src="/static/img/welcome2.png" alt="welcome" class="d-inline-block align-top" width="75" height="75" ></b> -->
            </template>
            <hr class="my-4">
            <span class="meta-bit">Account Activated!</span>
            <p class="meta">
            Welcome to UNPACME, thank you for activating your account! Before you get started, here are a few tips to keep in mind as you use our service.
            <br>
            </p>
            <br>
            <span class="meta-bit">How It Works</span>
            <p class="meta">
            UNPACME does not attempt to identify specific packers. We use multiple generic unpacking techniques in a recursive system. The outputs from this system are then fed into our classifier which automatically selects relevant artifacts to return to the user.
            <br><br>
            The classifier will always attempt to return well formed PE files that can be executed. However, some packers and unpacking techniques may make this impossible. In these cases the returned files will be a best approximation of the unpacked artifact and will only be suitable for static analysis.
            <br><br>
            Due to the nature of this system some analysis jobs may take longer than others. We attempt to complete all jobs in under two minutes but longer delays do occur for complex samples.
            </p>
            <br>
            <span class="meta-bit">Unpacked Children</span>
            <p class="meta">
            Some submissions may result in multiple unpacked children. UNPACME attempts to extract and return all stages of the packing process as well as any embedded artifacts. In the following scenarios multiple children will be returned.
            <br><br>
            <ul>
              <li>The malware is packed with multiple stages of packer - we will extract each stage.</li>
              <li>The malware contains both a loader and a payload - we will extract both of them.</li>
              <li>The malware relies on embedded DLLs or EXE files - we will extract all embedded PE files (even if they are benign libraries).</li>
            </ul>
            </p>
            <br>
            <span class="meta-bit">Your Account</span>
            <p class="meta">
            Once you have logged in your account will show your remaining submission quota for the month, as well as any rate limits that apply to your account. You can also find your API key here for automated access to UNPACME.
            </p>
            <br>
            <span class="meta-bit">Terms of Service</span>
            <p class="meta">
            Please ensure you are familiar with our <a target="_blank" href="/tos">terms of service</a>. UNPACME prohibits the use of our services to circumvent software copyright protections.
            </p>
            <br>
            <b-btn variant="dark" v-on:click="auth.login()">Sign In</b-btn>
        </b-jumbotron>
    </b-container>
</template>

<script>
import axios from 'axios';

export default {
    props: ['auth'],
    beforeCreate() {
        document.body.className = 'welcome';
    },
    metaInfo() {
        return {
            title: 'UnpacMe Welcome!',
            meta: [{ name: 'description', content: 'UnpacMe is an automated malware unpacking service. We provide malware analysis at Internet scale. Free for non-commercial use.' },
                { name: 'keywords', content: 'unpacking,unpacme,unpakme,unpackme,malware,malware analysis,analysis,automation,sandbox,oalabs,openanalysis,open analysis' }],
        };
    },
    // data() {
    //     if (this.auth.userProfile) {
    //         this.$nextTick(() => {
    //             this.profile = this.auth.userProfile;
    //         });
    //     } else {
    //         this.auth.getProfile((err, profile) => {
    //             if (err) return console.log(err);
    //             this.profile = profile;
    //             return null;
    //         });
    //     }
    //     return {
    //         profile: {},
    //         accessData: {},
    //     };
    // },
    methods: {
        getAccessData() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/access';
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    console.log(res.data);
                    this.accessData = res.data;
                })
                .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
                });
        },
        getAuthBearer() {
            this.accessToken = localStorage.getItem('access_token') || null;
            return `Bearer ${this.accessToken}`;
        },
    },
    created() {
        // this.getAccessData();
    },
};
</script>

<style>
  .profile-area img {
    max-width: 150px;
    margin-bottom: 20px;
  }

  .panel-body h3 {
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue